import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setActiveTenantId, getActiveTenantId } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const TenantCtx = createContext(null);

export function TenantProvider({ children }) {
  const { user } = useAuth();
  const [tenants, setTenants] = useState([]);
  const [activeTenantId, setActiveTenantIdState] = useState(() => getActiveTenantId());
  const [loaded, setLoaded] = useState(false);

  const switchTenant = useCallback((id) => {
    setActiveTenantIdState(id);
    setActiveTenantId(id);
  }, []);

  const loadTenants = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/tenants");
      setTenants(data);
      if (data.length > 0) {
        const current = getActiveTenantId();
        const valid = data.find((t) => t.id === current);
        if (!valid) {
          const fallback = user.tenant_id || data[0].id;
          switchTenant(fallback);
        }
      }
    } catch {}
    setLoaded(true);
  }, [user, switchTenant]);

  useEffect(() => {
    if (user && user !== false) loadTenants();
  }, [user, loadTenants]);

  const activeTenant = tenants.find((t) => t.id === activeTenantId) || null;

  return (
    <TenantCtx.Provider
      value={{ tenants, activeTenant, activeTenantId, switchTenant, refreshTenants: loadTenants, loaded }}
    >
      {children}
    </TenantCtx.Provider>
  );
}

export const useTenant = () => useContext(TenantCtx);
